/**
 * Checks if the entered URI already exists on the system.
 *
 * @author  Daniel Moffat
 */
'use strict';

const buildIcon = require("Scripts/common/build-icon");
const debounce = require('Scripts/common/debounce');
const Slugify = require('Vendor/slugify');

module.exports = UriAvailabilityChecker;

const DEFAULT_URI_INPUT_MIN_LENGTH = 6; // Also set in the Java

function UriAvailabilityChecker(el, target, minLength) {
	this.init = function() {
		this.ui = {
			input: $(el),
			basedOn: $($(el).data('basedOn')),
			result: $('.js-uri-lookup-result'),
			target: target,
			resetLink: $($(el).data('reset')),
		}

		if(!this.ui.input.length) {
			console.warn('Invalid element / selector', el);
			return;
		}

		this.minLength = minLength || DEFAULT_URI_INPUT_MIN_LENGTH;

		let data = this.ui.input.data();

		this.msg = {
			success: data?.successMsg || 'Available',
			error: data?.errorMsg || 'Not available',
			noBase: data?.nobaseMsg || 'Enter a value first',
			empty: data?.emptyMsg || 'Enter a value first',
			short: data?.shortMsg || 'Enter a longer value',
			unchanged: data?.unchangedMsg || 'This is your current URL',
		}

		this.bindEventHandlers();

		// If we already have a value, then trigger the validation
		if(this.ui.input.val().length) {
			this.ui.input.trigger('keyup');
		}
	};

	this.bindEventHandlers = function() {
		this.ui.input.on('keyup', debounce(this.onInputChanged.bind(this), 1000));
		this.ui.resetLink.on('click', this.onReset.bind(this));
	};

	this.onInputChanged = function(e) {
		Slugify.extend({'/':'-'}); // Change slashes to dashes

		var val = Slugify(this.ui.input.val(), {
			lower: true, 
			remove: /[^A-Za-z0-9-_\s]/g, // Spaces are "allowed" as Slugify auto-changes to dashes
		}); 

		var baseVal = this.ui.basedOn.val() || this.ui.input.data('default') || "";

		console.log("UriAvailabilityChecker.onInputChanged()", val, baseVal);

		// If the input has been cleared, remove any message that could've been there previously
		if(val.length === 0 && baseVal.length === 0) {
			this.showMessage(this.msg.noBase);
			return;
		}

		if(val.length === 0) {
			this.showMessage(this.msg.empty);
			return;
		}

		// Ensure at least N characters have been entered before sending the request.
		if(val.length < this.minLength) {
			this.showMessage(this.msg.short);
			return;
		}

		// Start the check - the isTrigger is so that we can loop the check by suffixing a number if the URI is taken when auto-generating
		this.runCheck(val, e.isTrigger ? 1 : 0);
	};

	this.runCheck = function(val, loop) {
		var oldUri = this.ui.input.data('oldUri');
		if(oldUri && oldUri == val) {
			this.showMessage(this.msg.unchanged, true);
			return;
		}

		this.checkAvailability(val).then(resp => {
			val = val.toLowerCase();

			// If auto-generated, we start a loop where the URI has been taken and just add a number until it's available
			if(!resp.success && loop && loop < 10){
				return this.runCheck(val.replace(/(-\d)?$/,'-'+loop), loop+1);
			}

			// Update the textbox with the real value (required when looping, but also useful if they've entered capital letters)
			this.ui.input.val(val);

			var message = resp.success ? this.msg.success : this.msg.error;
			this.showMessage(message, resp.success);

			// Update preview
			$(this.ui.input.data('preview')).html(val);
		});
	}

	this.showMessage = function(msg, success) {
		this.ui.result.empty().html(msg);

		var cssClass = 'text-orange';
		var faIcon = 'fa-circle-info';

		// success can be true/false/null
		switch(success) {
			case true: 
				cssClass = 'text-green';
				faIcon   = 'fa-circle-check';
				break;
			case false: 
				cssClass = 'text-red';
				faIcon   = 'fa-circle-xmark';
				break;
		}

		if(msg.length){
			this.ui.result
				.removeClass('text-orange')
				.removeClass('text-green')
				.removeClass('text-red')
				.addClass(cssClass + " no-clear") // .no-clear stops it being hidden by AjaxErrorHandler
				.prepend(buildIcon(faIcon, {size:'fa-lg'}) + ' ');
		}

		// Also show/hide the regenerate link
		this.ui.resetLink.collapse(success ? 'hide' : 'show');
	};

	this.checkAvailability = function(uri) {
		return $.ajax({
			url: this.ui.target,
			method: 'GET',
			data: { 
				uri: uri, 
				old: this.ui.input.data('oldUri') || '',
				id: this.ui.input.data('id') || '',
			}
		});
	};

	this.onReset = function(e) {
		this.ui.input.val(this.ui.input.data('default') || this.ui.input.data('oldUri') || '').trigger('keyup');
	}

	this.init();
}